var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ig-page-user-list" } },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: _vm.$t("ig.instagram") }], select: true } },
        [
          _vm.initialized && _vm.status.purchased
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  attrs: { type: "danger" },
                  on: { click: _vm.unsubscribe },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("wp.unsubscribe")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            {
              staticClass: "side-menubar-wrapper",
              staticStyle: { width: "15%" },
            },
            [
              _c("InstagramMenu", {
                attrs: { "selected-page": "contact-list" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content", staticStyle: { width: "85%" } },
            [
              !_vm.instagramPlanExists
                ? _c("ActivateInstagramAlert")
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c("h3", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("message.instagramContactList"))),
                ]),
                _vm._v(" "),
                _vm.selections.length
                  ? _c("div", { staticClass: "selection-bar" }, [
                      _c(
                        "section",
                        {
                          staticClass: "uncheck",
                          on: { click: _vm.unselectAll },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" arrow_back "),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "select", on: { click: _vm.selectAll } },
                        [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
                      ),
                      _vm._v(" "),
                      _c("section", { staticClass: "queries" }, [
                        _vm._v(
                          "+" +
                            _vm._s(_vm.selections.length) +
                            " contact selected"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "actions" },
                        [
                          _c(
                            "a-button",
                            { staticClass: "d-none", attrs: { ghost: "" } },
                            [_vm._v(_vm._s(_vm.$t("wp.sendBroadcastMessage")))]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "my-1",
                    staticStyle: {
                      width: "300px !important",
                      margin: "0px 5px !important",
                    },
                  },
                  [
                    _c("a-input-search", {
                      staticClass: "row search-input",
                      attrs: { placeholder: _vm.$t("message.search") },
                      on: {
                        input: function ($event) {
                          return _vm.onSearch($event.target.value)
                        },
                      },
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "a-table",
                      {
                        key: "vtable-" + _vm.renderCount,
                        staticClass: "custom-table",
                        attrs: {
                          columns: _vm.cols,
                          dataSource: _vm.getValidContacts,
                          pagination: _vm.pagination,
                          loading: _vm.loading,
                          locale: {
                            emptyText: _vm.$t("message.noContactFound"),
                          },
                          rowKey: "id",
                          size: "small",
                          "row-selection": {
                            onChange: _vm.rowSelectionOnChange,
                            selectedRowKeys: _vm.selections,
                          },
                        },
                        on: { change: _vm.handleTableChange },
                        scopedSlots: _vm._u([
                          {
                            key: "avatarSlot",
                            fn: function (data, item) {
                              return _c(
                                "div",
                                { staticClass: "p-1" },
                                [
                                  _c(
                                    "a-avatar",
                                    {
                                      staticStyle: {
                                        "background-color": "#3899ff",
                                        "border-radius": "7px !important",
                                      },
                                      attrs: {
                                        size: 30,
                                        shape: "square",
                                        username: item.full_name,
                                        src: _vm.getAvatarUrl(item),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$_.get(item, "full_name", "")
                                              .substr(0, 1)
                                              .toLocaleUpperCase()
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "id",
                            fn: function (data, item) {
                              return _c("div", { staticClass: "p-1" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.id.slice(0, -5)) +
                                    "\n                        "
                                ),
                              ])
                            },
                          },
                          {
                            key: "name",
                            fn: function (data, item) {
                              return _c("div", { staticClass: "p-1" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.full_name || item.username) +
                                    "\n                        "
                                ),
                              ])
                            },
                          },
                          {
                            key: "isFollower",
                            fn: function (data, item) {
                              return _c("div", { staticClass: "p-1" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      item.isFollower ? "Follower" : "Following"
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            },
                          },
                          {
                            key: "action",
                            fn: function (data, item) {
                              return _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-content-end",
                                    staticStyle: {
                                      "margin-right": "-10px !important",
                                    },
                                  },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                              theme: _vm.isDarkMode
                                                ? "light-border"
                                                : "google",
                                            },
                                            expression:
                                              "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                          },
                                        ],
                                        staticClass: "igStartChat",
                                        attrs: {
                                          content: _vm.$t("wp.startChatWp"),
                                          "data-v-step": "16",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.startChat(item.pk_id)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.$t("wp.startChatWp")) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "30px",
                                              height: "30px",
                                            },
                                          },
                                          [
                                            _c("InstagramIcon", {
                                              attrs: { width: 30, height: 30 },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            },
                          },
                        ]),
                      },
                      [_c("div")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }